
import React from 'react';
import { Button } from '@/components/ui/button';
import { Ship } from 'lucide-react';
import WaveAnimation from './WaveAnimation';

const HeroSection = () => {
  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');
    contactSection?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative min-h-screen flex items-center bg-gradient-to-b from-ocean-100 to-ocean-200 bg-waves overflow-hidden">
      <div className="container mx-auto px-4 pt-20 pb-32 z-10">
        <div className="max-w-3xl mx-auto text-center">
          <div className="inline-flex items-center justify-center p-2 bg-white/20 backdrop-blur-sm rounded-full mb-6 animate-float">
            <Ship className="text-ocean-600 mr-2" size={24} />
            <span className="text-ocean-800 font-medium">Dive Shop Quote Generator</span>
          </div>
          
          <h1 className="text-4xl md:text-6xl font-bold text-ocean-800 mb-6">
            Create beautiful, professional dive quotes 
            <span className="text-ocean-600"> offline — fast.</span>
          </h1>
          
          <p className="text-lg md:text-xl text-ocean-700 mb-10">
            A simple yet powerful tool designed specifically for dive shop owners and managers. 
            Generate professional quotes in seconds, customize to your brand, and export to PDF.
          </p>
          
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <Button 
              onClick={scrollToContact}
              className="text-lg py-6 px-8 bg-ocean-600 hover:bg-ocean-700 shadow-blue"
            >
              Request Early Access
            </Button>
            <Button 
              variant="outline" 
              className="text-lg py-6 px-8 bg-white/70 text-ocean-700 hover:bg-white/90 border-ocean-300"
              onClick={scrollToContact}
            >
              Learn More
            </Button>
          </div>
        </div>
      </div>
      <WaveAnimation />
    </section>
  );
};

export default HeroSection;
